<script>
import gql from 'graphql-tag'

export default {
  props: [
    'countryID',
  ],
  name: 'SelectCountries',
  computed: {
    countryIDModel: {
      get() {
        return this.countryID
      },

      set(val) {
        this.$emit('countryIDChanged', val)
      }
    }
  },
  apollo: {
    countries: {
      query: gql`query {countries {    name    id   }}`,
      client: 'public',
      update(data) {
        const countries = data.countries

        if (countries.length > 0) {
          this.countryIDModel = countries[0].id
        }

        return countries.map((item) => {
          return {
            text: item.name,
            value: item.id,
          }
        })
      }
    },
  },
}
</script>

<template>
  <v-select
      v-if="countryIDModel != null"
      :items="countries"
      label="Страна"
      v-model="countryIDModel"
  >
  </v-select>
</template>
